import { Geotab } from "@fairfleet/geotab";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";

export function useDiagnosticsBySearch(search: string, disabled?: boolean, limit?: number) {
  // const queryClient = useQueryClient();

  const { geotabClient, activeSessionId } = useGeotabClient();
  search = search.trim();
  search = search.replace("%", "");

  return useQuery({
    queryKey: ["diagnosticsBySearch", activeSessionId, search],

    queryFn: async ({ signal }) => {
      const diagnostics = await getDiagnostics(geotabClient, search, signal, limit);
      /*for (const diagnostic of diagnostics) {
            queryClient.setQueryData(["diagnostic", diagnostic.id], diagnostic);
        }*/
      return diagnostics;
    },

    placeholderData: keepPreviousData,
    enabled: !disabled,
  });
}

export async function getDiagnostics(
  geotabClient: Geotab,
  search: string,
  signal?: AbortSignal,
  limit?: number,
  exactMatch = false,
) {
  if (search.length <= 3) {
    return geotabClient.get("Diagnostic", {}, limit ?? 10000, signal);
  }
  return geotabClient.get(
    "Diagnostic",
    {
      name: exactMatch ? search : `%${search}%`,
    },
    limit ?? 10000,
    signal,
  );
}
